import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-navigation",
  templateUrl: "./med-icon-navigation.component.html",
})
export class MedIconNavigationComponent extends SvgMixinComponent {}
